import { jsxs as j, jsx as m } from "react/jsx-runtime";
import { FileSourceEnum as A } from "@systemeio/file-manager";
import { useEditor as F, EditorContent as P } from "./node_modules/@tiptap/react/dist/index.mjs";
import z from "./_virtual/index.mjs";
import { useState as q, useEffect as E } from "react";
import { twMerge as g } from "tailwind-merge";
import { CharacterCount as G } from "./components/character-count.mjs";
import { baseExtensions as H } from "./constants/default-extensions.mjs";
import { EDITOR_PADDING as b } from "./constants/default-styles.mjs";
import { EditorExtensionEnum as W } from "./enums/editor-extensions-enum.mjs";
import { useUpdateLinkColor as _ } from "./extensions/link-extension/use-update-link-color.mjs";
import { useImageDropAndUpload as J } from "./extensions/image-extension/use-image-drop-and-upload/index.mjs";
import { useInitContentWithLinkifiedText as K } from "./extensions/link-extension/use-init-content-with-linkified-text.mjs";
import { Toolbar as Q } from "./toolbar/index.mjs";
import { getExistingExtensions as V, getExtensions as X } from "./utils/get-extensions.mjs";
import { convertStyleObjectToCss as Y } from "./utils/style-helpers.mjs";
import { FontFamilyEnum as Z } from "./extensions/font-family-extension/utils.mjs";
const ht = ({
  mode: d = "html",
  content: r,
  isPreFetching: u,
  isEditable: s = !0,
  substitutions: x,
  extensions: l = H,
  className: y,
  fileSource: f = A.TextEditor,
  toolbarStyles: C,
  characterCountHint: T,
  style: v,
  toolbarClassName: I,
  extensionOption: o,
  showAllItems: w,
  skeletonClassName: D,
  defaultFont: L = Z.TimesNewRoman,
  onBlur: n,
  onChange: N
}) => {
  var h;
  const { onDrop: k, onPaste: S } = J(f), [p, M] = q(!1), i = d === "html" ? "getHTML" : "getText", a = Array.from(new Set(l)), { hasImage: c, hasCharacterCount: R, hasSimpleLink: U } = V(a), t = F({
    content: r,
    immediatelyRender: !1,
    onCreate: () => M(!0),
    extensions: X(a, o),
    onUpdate: ({ editor: e }) => p && N(e.isEmpty ? "" : e[i]()),
    onBlur: ({ editor: e }) => p && (n == null ? void 0 : n(e.isEmpty ? "" : e[i]())),
    editorProps: {
      handlePaste: c ? S : void 0,
      handleDrop: c ? k : void 0,
      attributes: {
        class: g(
          "border",
          "border-text-secondary/30",
          "main-transition-colors",
          "min-h-[500px]",
          "w-full",
          "focus:outline-hidden",
          "focus:border-brand-primary",
          "overflow-auto",
          "rounded-b-lg",
          !s && "pointer-events-none cursor-default",
          y
        ),
        style: Y({
          paddingLeft: b,
          paddingRight: b,
          fontFamily: L,
          ...v
        })
      }
    }
  });
  return K({
    editor: t,
    content: r,
    shouldInitialize: U && d === "text"
  }), E(() => {
    t && t.setOptions({ editable: s && !u });
  }, [s, u, t]), E(() => {
    if (!t) return;
    const e = z(() => {
      t[i]() !== r && t.commands.setContent(r ?? "", { emitUpdate: !1 });
    }, 300);
    return e(), () => {
      e.cancel();
    };
  }, [r, t, i]), _(t, (h = o == null ? void 0 : o[W.Link]) == null ? void 0 : h.color), t != null && t.isInitialized ? /* @__PURE__ */ j("div", { className: "relative", children: [
    l.length !== 0 && /* @__PURE__ */ m(
      Q,
      {
        editor: t,
        substitutions: x,
        extensions: a,
        toolbarStyles: C,
        fileSource: f,
        toolbarClassName: I,
        showAllItems: w,
        extensionOption: o
      }
    ),
    /* @__PURE__ */ m(P, { editor: t }),
    R && /* @__PURE__ */ m(
      G,
      {
        editor: t,
        hint: T,
        className: "ml-auto mt-2 mr-2 w-fit"
      }
    )
  ] }) : /* @__PURE__ */ m(
    "div",
    {
      className: g(
        "bg-background-tertiary h-[500px] w-full animate-pulse rounded-lg",
        D
      )
    }
  );
};
export {
  ht as TipTapEditor
};
